import React from "react";

import { DSCardWrapper } from "../design-system/molecules";

export function EmailExportTypeRadioButton({
  title,
  description,
  onChange,
  value,
  currentValue,
}) {
  const isSelected = value === currentValue;

  return (
    <DSCardWrapper
      variant={isSelected ? "info" : "default"}
      interactive
      onClick={() => onChange(value)}
      dataTestId={`email-export-type-${value}`}
      aria-label={`${title}: ${description}`}
      padding="p-3"
    >
      <div className="flex flex-row items-center space-x-2">
        <input
          onChange={() => {
            onChange(value);
          }}
          checked={isSelected}
          type={"radio"}
          value={value}
          className="accent-brand"
        />
        <label>
          <h5
            className={`font-semibold cursor-pointer ${
              isSelected ? "text-brand" : "text-primary"
            }`}
          >
            {title}
          </h5>
        </label>
      </div>
      <p className="text-xs text-secondary">{description}</p>
    </DSCardWrapper>
  );
}
